module.exports = __webpack_public_path__ + "static/media/Sarabun.60bddd6b.ttf";